/* eslint-disable no-unused-vars */
import { Divider, Steps, Row, Col, message, Spin } from "antd";
import React, { useState, useEffect } from "react";
// import BasicDetails from "./BasicDetails";
// import "./style.scss";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import Heading from "../../components/Heading";
import BranchAdmin from "./BranchAdmin";
import BranchDetails from "./BranchDetails";
import DeliveryDetails from "./DeliveryDetails";
import API from "../../api";

import urls from "../../api/urls";
import { useParams } from "react-router-dom";

const {
  POST_LEAD_CP_DETAILS,
  UPDATE_LEAD_CP_DETAILS,
  GET_CP_LEAD_ID,
  GET_ALL_CP_LEADS,
} = urls;

const CPLeadList = () => {
  // const navigate = useCustomNavigate();navigate = useCustomNavigate();;

  const [current, setCurrent] = useState(0);
  const [sideStepHide, setSideStepHide] = useState(false);
  const [getData, setGetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cpLeadId, setcpLeadId] = useState(null);
  const userId = JSON.parse(localStorage.getItem("userId"));

  useEffect(() => {
    const leadCPId = localStorage.getItem("leadCPId");
    if (leadCPId) {
      getCPDetails_(leadCPId);
    }
    window.scrollTo(0, 0);
  }, [current]);

  const getCPDetails_ = async (clientId) => {
    let response = await API.Api(
      GET_CP_LEAD_ID + `${clientId}`
    ).getCustomHeader({ "USER-ID": userId?.userInfo?.userId });
    let data = response?.response?.data;
    // if (data.basicDetail.leadName !== null) {
    //   setCurrent(1);
    // } else if (data.deliveryDetails.areas.areas !== null) {
    //   setCurrent(4);
    // } else if (data.rateCard.isAllocated) {
    //   setCurrent(3);
    // } else if (data.cpDetail.premiseName !== null) {
    //   setCurrent(2);
    // }
    // setStepsData(data);
    setGetData(data);
  };

  const patchClient = async (values) => {
    setLoading(true);
    const leadCPId = localStorage.getItem("leadCPId");
    let response = await API.Api(UPDATE_LEAD_CP_DETAILS).putCustomHeader(
      { leadId: +leadCPId, ...values },
      { "USER-ID": userId?.userInfo?.userId }
    );
    if (response?.status) {
      setLoading(false);
      message.success("Data added successfully.");
      setCurrent(current + 1);
    } else {
      setLoading(false);
    }
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const handleStepsChange = (item, err) => {
    setCurrent(current + 1);
    setcpLeadId(item);
  };

  const goBackStep = () => {
    window.scrollTo(0, 0);
    setCurrent(current - 1);
  };

  const sideStepHideFunc = () => {
    setSideStepHide(true);
  };

  const sideStepShowFunc = () => {
    setSideStepHide(false);
  };

  return (
    <div className="p-2">
      <Heading title="Request for branch" />
      <div className="">
        <div className="master-main-container">
          {/* <Spin
            spinning={loading}
            indicator={
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            }
          > */}
          <Row
            className={sideStepHide ? "" : "p-1"}
            style={{ height: "70vh", overflow: "scroll" }}
          >
            {!sideStepHide && (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={6}
                className="global-steps-container"
              >
                <Steps
                  current={current}
                  direction="vertical"
                  onChange={onChange}
                  items={[
                    {
                      title: "Branch Admin",
                      description: "Please provide your details",
                    },
                    {
                      title: "Branch Details",
                      description: "Please provide branch details",
                      // disabled: stepsData?.pincodeMapping ? false : true,
                    },
                    {
                      title: "Delivery Details",
                      description: "Please provide delivery details",
                      // disabled: stepsData?.pincodeMapping ? false : true,
                    },
                  ]}
                />
              </Col>
            )}
            <Col xs={24} sm={24} md={24} lg={24} xl={sideStepHide ? 24 : 18}>
              {current === 0 ? (
                <BranchAdmin
                  handleStepsChange={handleStepsChange}
                  patchClient={patchClient}
                  getData={getData}
                  goBackStep={goBackStep}
                />
              ) : current === 1 ? (
                <BranchDetails
                  handleStepsChange={handleStepsChange}
                  patchClient={patchClient}
                  getData={getData}
                  goBackStep={goBackStep}
                />
              ) : current === 2 ? (
                <DeliveryDetails
                  handleStepsChange={handleStepsChange}
                  sideStepsHide={sideStepHideFunc}
                  sideStepsShow={sideStepShowFunc}
                  goBackStep={goBackStep}
                  rateCardPresent={getData?.ratecard || false}
                  // clientName={getData?.clientOnboard?.clientName}
                />
              ) : (
                ""
              )}
            </Col>
          </Row>
          {/* </Spin> */}
        </div>
      </div>
    </div>
  );
};

export default CPLeadList;
